import { observable, computed } from 'mobx'
import Api from '@api/xiu_yan/homeApi'
import { HLJ_STATISTIC, getMerchantInfo } from '@util'

class Store {
  @observable taskSchedule = null
  @observable previewModalVisible = false

  @computed
  get showTaskSchedule() {
    return !!this.taskSchedule
  }

  getTaskSchedule = async () => {
    const { data } = await Api.getTaskSchedule()
    this.taskSchedule = data
    if (data.status === 0) {
      this.previewModalVisible = true
      HLJ_STATISTIC({
        page_name: '首婚礼纪商家后台页',
        event_type: 'element_view',
        element_tag: 'new_growth_plan_view',
        data_id: getMerchantInfo().id,
        data_type: 'Merchant'
      })
      Api.changeScheduleStatus()
    }
  }

  togglePreviewModal = bool => () => {
    this.previewModalVisible = bool
  }
}

export default Store
